import { BringzzIcon } from "@bringzz/components";

export const alphabets = ['#', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export const getCategories = (t) => [
    {
        name: t('component.search.categories.companies.name'),
        shortName: t('component.search.categories.companies.short'),
        icon: <BringzzIcon
            size="34"
            icon="IconBuildingAlt1"
            folder="LineIcons"
        />,
        component: "Companies"
    },
    {
        name: t('component.search.categories.local_pharmacies.name') || 'Local Pharmacies',
        shortName: t('component.search.categories.local_pharmacies.short') || 'Local Pharmacies',
        icon: <BringzzIcon
            size="34"
            icon="IconPharmacyAlt"
            folder="HealthIcons"
        />,
        items: [],
        isPharmacyList: true
    },
];

export const getProductGroups = (t) => [
    {
        name: t('component.search.product_groups.prescription_medicine.name') || 'Prescription Medicine',
        shortName: t('component.search.product_groups.prescription_medicine.short') || 'Prescription Medicine',
        icon: <BringzzIcon
            size="34"
            icon="IconPrescriptionDocument"
            folder="HealthIcons"
        />,
        isRxProducts: true
    },
];

// Keep the original categories export for backward compatibility
export const categories = [];
{/* 
export const groupsBy = [
    {
        label: "Product Groups",
        items: [
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
        ]
    },
    {
        label: "Products by Symptoms",
        items: []
    },
    {
        label: "Products by Activity",
        items: [
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
        ]
    },
    {
        label: "Products by Organes",
        items: [
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
        ]
    },
    {
        label: "Product by Age Groups",
        items: [
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
        ]
    },
    {
        label: "Products by Diseases",
        items: [
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
            {
                name: "Prescription Medicine",
                shortName: "Prescription Medicine",
                icon: <BringzzIcon
                    size="34"
                    icon="IconPrescriptionDocument"
                    folder="HealthIcons"
                />
            },
        ]
    },
    {
        label: "Products by Symptoms",
        items: []
    },
]

*/}